var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"ch-link",class:{ active: _vm.isActive },on:{"click":_vm.viewDocument}},'button',_vm.$attrs,false),[_vm._v(" Download ")])
}
var staticRenderFns = []

export { render, staticRenderFns }